import { render, staticRenderFns } from "./CorrespondentsLov.vue?vue&type=template&id=d8598872&"
import script from "./CorrespondentsLov.vue?vue&type=script&lang=js&"
export * from "./CorrespondentsLov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports